import { Footer } from './Footer'
import React, { Component } from 'react'
import { Row, Col, Card, Container } from 'react-bootstrap'
import PesoTalla1 from './PesoTalla/PesoTalla1.jpg'
import PesoTalla2 from './PesoTalla/PesoTalla2.jpg'
import PesoTalla3 from './PesoTalla/PesoTalla3.jpg'
import PesoTalla4 from './PesoTalla/PesoTalla4.jpg'
import { Navigation } from './Navigation'

export class Talla extends Component {
    render() {
        const items = [
            { img: PesoTalla1, title: "Tallimetro/Infantometro" },
            { img: PesoTalla2, title: "Tallimetro/Infantometro" },
            { img: PesoTalla3, title: "Balanza Pedriátrica" },
            { img: PesoTalla4, title: "Balanza para adulto y balanza de piso" }
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Peso y Talla</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Usamos lg={2} para que las balanzas y tallímetros 
                        se vean grandes y la información sea legible.
                    */}
                    <Row xs={1} md={2} lg={2} className="g-5 text-center">
                        {items.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                height: '500px', 
                                                objectFit: 'contain',
                                                padding: '10px'
                                            }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.5rem', padding: '10px' }}>
                                            {item.title}
                                        </Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}